import { Table } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import { Link } from 'react-router-dom';

import { useScheduleFlows } from 'components/settings/components/sections/openingHours/utils/useScheduleFlows';

import { TableFlowRow } from '../../../tableFlowRow/tableFlowRow';

import styles from './tableFlows.module.scss';

type Props = {
  numberOfFlows: number;
  scheduleId: string;
};

const numberOfFlowsToFetch = 10;

export const TableFlows = ({
  numberOfFlows,
  scheduleId,
}: Props): JSX.Element => {
  const { asyncStatus, currentPageFlows: flows } = useScheduleFlows(
    scheduleId,
    numberOfFlowsToFetch,
  );

  return (
    <Table framed={false} loading={asyncStatus === 'pending'}>
      <Table.Tbody>
        {flows.length ? (
          <>
            {flows.map((flow) => (
              <TableFlowRow key={flow.id} scheduleId={scheduleId} {...flow} />
            ))}
            {numberOfFlows > numberOfFlowsToFetch && (
              <Table.Tr>
                <Table.Td>
                  <Link
                    style={{ color: typography.color.link }}
                    to={`/settings/businesshours/${scheduleId}/flows`}
                  >
                    ... and {numberOfFlows - numberOfFlowsToFetch} more
                  </Link>
                </Table.Td>
              </Table.Tr>
            )}
          </>
        ) : (
          <Table.Tr>
            <Table.Td className={styles.unusedSchedule}>
              This schedule is currently not used in any flows.
            </Table.Td>
          </Table.Tr>
        )}
      </Table.Tbody>
    </Table>
  );
};
